/**
 * Split visible free cards + sticky pair into two columns with balanced card counts.
 * Sticky pair stays stacked in one column (pair[0] then pair[1]).
 *
 * @param {Array} freeCards - ordered free section cards
 * @param {Array} stickyPair - 0–2 cards (e.g. actions then history)
 * @returns {{ left: Array, right: Array }}
 */
export function balanceTaskDetailColumns(freeCards = [], stickyPair = []) {
  const free = Array.isArray(freeCards) ? freeCards : [];
  const pair = Array.isArray(stickyPair) ? stickyPair.filter(Boolean) : [];
  const n = free.length;
  const p = pair.length;

  if (p === 0) {
    const mid = Math.ceil(n / 2);
    return { left: free.slice(0, mid), right: free.slice(mid) };
  }

  const total = n + p;
  const leftTarget = Math.ceil(total / 2);

  // Prefer sticky pair on the right (matches approved mock: left 4 | right 3).
  if (leftTarget <= n) {
    return {
      left: free.slice(0, leftTarget),
      right: [...free.slice(leftTarget), ...pair]
    };
  }

  const rightTarget = Math.floor(total / 2);
  return {
    left: [...free.slice(0, Math.max(0, n - rightTarget)), ...pair],
    right: free.slice(Math.max(0, n - rightTarget))
  };
}
